export default __webpack_public_path__ + "static/media/sandeep (3).90fea633.png";